import Api from '@/services/Api'

export default {
  register(info) {
    return Api().post('register', info);
  },
  resetPassword(username) {
    return Api().post('resetPassword', {username: username});
  },
  recoverPassword(payload) {
    return Api().post('recoverPassword', payload);
  },
  setPassword(payload) {
    return Api().post('setPassword', payload);
  },
  login(credentials) {
    return Api().post('login', credentials);
  },
  classroomLogin(credentials) {
    return Api().post('classroomLogin', credentials);
  },
  processVerificationCode(payload) {
    return Api().post('processVerificationCode', payload);
  },
  resendVerificationCode() {
    return Api().post('resendVerificationCode');
  },
  checkUsernameAvailability(payload) {
    return Api().post('checkUsernameAvailability', payload);
  },
  getInvitationWithCode(code) {
    return Api().get(`invitations/${code}`)
  },
  registerWithInvitation(payload) {
    return Api().post('registerWithInvitation', payload)
  },
  joinWithInvitation(code) {
    return Api().post('joinWithInvitation', code)
  }
}